function setProductSliderResize(){
    if (window.matchMedia("(min-width: 993px)").matches) {
        $('.bn--product-horizontal__slider').slick('unslick');

    }else{
        $('.bn--product-horizontal__slider').unbind('init');
        $('.bn--product-horizontal__slider').unbind('reInit');
        $('.bn--product-horizontal__slider:not(.slick-initialized )').slick({
            slidesToShow: 4,
            // slidesToScroll: 1,
            // draggable: true,
            // centerMode: true,
            // centerPadding: "340px",
            dots: false,
            // autoplay: false,
            adaptiveHeight: true,
            prevArrow: "<button type=\"button\" class=\"arrow_prev bn--product-slider__arrow__prev\">\n        <svg width=\"45\" height=\"45\" viewBox=\"0 0 45 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <rect width=\"45\" height=\"45\" rx=\"22.5\" fill=\"white\"/>\n    <path d=\"M24.75 15L17.25 22.5L24.75 30\" stroke=\"black\"/>\n    </svg>\n    </button>",
            nextArrow: "<button type=\"button\" class=\"arrow_next bn--product-slider__arrow__next\">\n    <svg width=\"45\" height=\"45\" viewBox=\"0 0 45 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <rect width=\"45\" height=\"45\" rx=\"22.5\" fill=\"white\"/>\n    <path d=\"M20.25 30L27.75 22.5L20.25 15\" stroke=\"black\"/>\n    </svg>\n    </button>",
            responsive: [{
                breakpoint: 2000,
                settings: {
                    slidesToShow: 3,
                    centerMode: false
                }
            }, {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 2,
                    centerMode: false,
                    dots: true
                }
            }, {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    dots: true,
                    prevArrow: false,
                    nextArrow: false,
                }
            }]
        });
    }
}
$(window).resize(function (){
    setProductSliderResize()
})
$('.js-product-accordion-toggle').on('click',function (){
    $(this).closest('.bn--product__accordion').toggleClass('open');
})


function ProductSliderPosition() {
    const $productHead = $(".bn--product-template-top-left__wrapper");
    const $productHeadWrapper = $(".bn--product-horizontal__slider.redesign-slider");
    const $productBody = $(".bn--product-single");
    const scrollValue = window.pageYOffset;
    const $header = $("#shopify-section-header");
    const headerHeight =15;
    const windowHeight = document.documentElement.clientHeight;
    if(($productBody.height() - $productHeadWrapper.height()) >50 ){
    if ($productHead.is("*") && $productBody.is("*")) {
            const productHeadRect = $productHead[0].getBoundingClientRect();
            const productBodyRect = $productBody[0].getBoundingClientRect();
            const productHeadWrapperRect =
                $productHeadWrapper[0].getBoundingClientRect();

            $productHeadWrapper.css(
                "width",
                `${$productHeadWrapper.css("width")}`
            );

            if (productHeadRect.y - headerHeight < 16) {
                $productHeadWrapper.css("position", "fixed");
                $productHeadWrapper.css(
                    "left",
                    `${productHeadRect.left}px`
                );
                if (
                    productHeadWrapperRect.top >= headerHeight &&
                    productHeadWrapperRect.height + headerHeight <
                    productBodyRect.bottom
                ) {
                    $productHeadWrapper.css("top", `${headerHeight}px`);
                    $productHeadWrapper.css("bottom", `auto`);

                } else {
                    $productHeadWrapper.css("top", `auto`);

                    $productHeadWrapper.css(
                        "bottom",
                        `${-(
                            productBodyRect.height -
                            Math.abs(productBodyRect.top) -
                            windowHeight
                        )}px`
                    );
                }
            } else {
                $productHeadWrapper.css("position", "relative");
                $productHeadWrapper.css("left", `0px`);
                $productHeadWrapper.css("top", `0`);
                $productHeadWrapper.css("width", `100%`);
            }

    }
    }
}
window.addEventListener("scroll", function () {
    if (window.matchMedia("(min-width: 993px)").matches) {
        ProductSliderPosition();
    }
});
window.addEventListener("resize", function () {
    if (window.matchMedia("(min-width: 993px)").matches) {
        ProductSliderPosition();
    }
});

if ($('.baby-bat').length === 0 || $('.main-product-template.main-product').length > 0) {
    function closeEngravingPopup(){
        $('.engraving-popup').removeClass('open');
        $('body').removeClass('popup-open');
    }
    function openEngravingPopup(e){
        $('.engraving-popup').addClass('open');
        $('body').addClass('popup-open');
    }
    function cancelEngraving(){
        $('.engraving-popup').find('.engraving-popup-input-wrapper input').val('');
        $('.engraving-popup').find('.js-engraving-popup-image .text')[0].innerHTML='Smith';
        closeEngravingPopup();
        $('.engraving-selected-info').hide();
        $('.js-add-engraving').show();
        $(".js-engraving-wrapper").removeClass('added');
    }
    $('.js-add-engraving').on('click',function (){
        openEngravingPopup();
    });
    $('.js-engraving-edit').on('click',function (){
        openEngravingPopup();
    });
    $('.js-engraving-popup-close').on('click',function (){
        closeEngravingPopup();
    })
    $('.engraving-popup-input-controls .switch input').on('change',function (){
        if(this.checked == true){
            $(this).closest('.engraving-popup-content').addClass('font-block ');
            $(this).closest('.engraving-popup-input-controls').find('.engraving-popup-input-controls-value').removeClass('active');
            $(this).closest('.engraving-popup-input-controls').find('.engraving-popup-input-controls-value.js-block-font').addClass('active');
        }else{
            $(this).closest('.engraving-popup-content').removeClass('font-block ');
            $(this).closest('.engraving-popup-input-controls').find('.engraving-popup-input-controls-value').removeClass('active');
            $(this).closest('.engraving-popup-input-controls').find('.engraving-popup-input-controls-value.js-script-font').addClass('active');
        }
    });
    $('.engraving-popup-input-wrapper input').on('input focus',function (){
        $(this).closest('.engraving-popup-content').find('.js-engraving-popup-image .text')[0].innerHTML= this.value
    });

    $('.engraving-popup-submit').on('click',function (e) {
        e.preventDefault();
        const popup_input = $(this).closest('.engraving-popup').find('.engraving-popup-input-wrapper input');
        const popup_switch = $(this).closest('.engraving-popup').find('.engraving-popup-input-controls input');
        const engraving_info = $('.engraving-selected-info');
        const engraving_btn= $('.js-add-engraving');
        let font_style = "Block font"
        if(popup_input.val() != '') {
            if (popup_switch[0].checked) {
                font_style = "Block font";
                engraving_info.find('.selected-text').removeClass('script-font');
            } else {
                font_style = "Script font";
                engraving_info.find('.selected-text').addClass('script-font');
            }
            engraving_info.find('.selected-text')[0].innerHTML = popup_input.val();
            engraving_info.show();
            engraving_btn.hide();
            $(".js-engraving-wrapper").addClass('added');
            closeEngravingPopup()
        }else{
            popup_input.addClass('error');
        }
    })
    $('.engraving-popup-cancel').on('click',function (e) {
        e.preventDefault();
        cancelEngraving();
    });
    $('.js-engraving-cart-button').on('click',function (e){
        e.preventDefault();
        if( $(".js-engraving-wrapper").hasClass('added')){
            const engravingWrapper =  $(".js-engraving-wrapper");
            const engravingPopup =  $(".engraving-popup ");
            const engravingProduct = JSON.parse($(".js-engraving-wrapper").find('.js-engraving-product-json').find('[type="application/json"]')[0].innerHTML);
            const productTitle = $(".js-engraving-wrapper").find('.js-engraving-product-json').find('.product_name')[0].innerHTML;
            const engravingText = engravingPopup.find('.engraving-popup-input-wrapper input').val();
            const engravingFont = engravingPopup.find('.engraving-popup-input-controls-value.active')[0].innerHTML;
          const urlParams = new URLSearchParams(window.location.search);
          const baseProductId = urlParams.get('variant');

            let formData = {
                'items': [{
                    'id': engravingProduct.id,
                    'quantity': 1,
                    "properties" : {
                        "Text": engravingText,
                        "Font": engravingFont,
                        "Bat": productTitle,
                        "_engravingBaseProduct": parseInt(baseProductId)
                    }
                }]
            };
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then(response => {
                    console.log("sucsses")
                    $(this).closest('.bn--product-form__controls-group').find('.bn--product-form__cart-submit.engraving-cart-button-hide').click();
                    cancelEngraving()
                    setTimeout(cancelEngraving(), 1000)
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                    console.error('Error:');
                });
        }else{
            $(this).closest('.bn--product-form__controls-group').find('.bn--product-form__cart-submit.engraving-cart-button-hide').click();
        }
    })
}

$('.js-compare-slider').slick({
    slidesToShow: 6,
    // slidesToScroll: 1,
    // draggable: true,
    centerMode: true,
    // centerPadding: "340px",
    dots: false,
    // autoplay: false,
    adaptiveHeight: true,
    prevArrow: "<button type=\"button\" class=\"arrow_prev bn--product-slider__arrow__prev\">\n        <svg width=\"45\" height=\"45\" viewBox=\"0 0 45 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <rect width=\"45\" height=\"45\" rx=\"22.5\" fill=\"white\"/>\n    <path d=\"M24.75 15L17.25 22.5L24.75 30\" stroke=\"black\"/>\n    </svg>\n    </button>",
    nextArrow: "<button type=\"button\" class=\"arrow_next bn--product-slider__arrow__next\">\n    <svg width=\"45\" height=\"45\" viewBox=\"0 0 45 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <rect width=\"45\" height=\"45\" rx=\"22.5\" fill=\"white\"/>\n    <path d=\"M20.25 30L27.75 22.5L20.25 15\" stroke=\"black\"/>\n    </svg>\n    </button>",
    responsive: [{
        breakpoint: 1400,
        settings: {
            slidesToShow: 5,
            centerMode: false
        }
    }, {
        breakpoint: 1250,
        settings: {
            slidesToShow: 3,
            centerMode: false
        }
    }, {
        breakpoint: 769,
        settings: {
            slidesToShow: 2,
            dots: false,
            arrows: false,
            centerMode: false
        }
    },
                {
        breakpoint: 475,
        settings: {
            slidesToShow: 1,
            dots: false,
            arrows: false,
            centerMode: false
        }
    }]
    });
